import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';

type ServerMediaItem = { Id?: string; Name?: string; Size?: string | number; duration?: number };

export function mapServerMediaItemsToFiles(items: ServerMediaItem[]): TFileWithMeta[] {
  const now = new Date().toISOString();
  return items.map((m) => {
    const duration = Number(m.duration ?? 0);
    const hasDuration = Number.isFinite(duration) && duration > 0;

    return {
      meta: {
        id: m.Id ?? '',
        name: m.Name ?? '',
        size: Number(m.Size) || 0,
        percent: 100,
        status: 'external' as const,
        uploadedAt: now,
        extra: {
          duration,
          mediaId: m.Id ?? undefined,
          analysisStatus: hasDuration ? 'done' : 'progress',
        },
      },
    };
  });
}
